export { Toggle } from "./component";
export type { ToggleProps, ToggleSize, ToggleStyleProps } from "./types";
